module.exports = __webpack_public_path__ + "img/mailLi.eb3b9930.svg";